import {
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { IColDef } from './DataTable';

const SlideDataTable: React.FC<{
  rows: any[];
  columns: IColDef[];
  page: number;
  pageSize: number;
  openArr?: {
    [key: string]: boolean;
  };
  // slideComponent?: React.FC<{ word: string }>;
  // SlideComponent?: React.ReactNode;
  SlideComponent?: any;
  slideComponentProps?: any;
  orderBy?: string;
  order?: 'asc' | 'desc';
  setOrderBy?: (val) => void;
  setOrder?: (val) => void;
  loading?: boolean;
  allOpen?: boolean;
  toggleExpandAll?: () => void;
}> = ({
  rows,
  page,
  pageSize,
  loading,
  columns,
  openArr,
  SlideComponent,
  slideComponentProps,
  order,
  orderBy,
  setOrder,
  setOrderBy,
  allOpen,
  toggleExpandAll,
}) => {
  const [localItems, setLocalItems] = useState<Array<Record<string, any>>>(
    rows
  );

  useEffect(() => {
    let startRow = (page - 1) * pageSize;
    startRow = startRow < 0 ? 0 : startRow;
    const endRow = startRow + pageSize;
    const paginatedRows = rows.slice(startRow, endRow);
    setLocalItems(paginatedRows);
  }, [rows, page, pageSize]);

  const colKeys = columns.map((col) => col.field);

  const renderHelper = (columns: IColDef[], item: any, keyName: string) => {
    const col = columns.find((col) => col.field === keyName);
    if (col?.renderCell) {
      return col?.field === 'id'
        ? col.renderCell(item[keyName])
        : col.renderCell(item);
    } else if (col?.valueFormatter) {
      return col.valueFormatter(item);
    } else {
      return item[keyName];
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder?.(isAsc ? 'desc' : 'asc');
    setOrderBy?.(property);
  };

  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  const handler = useCallback(() => {
    if (toggleExpandAll) {
      return toggleExpandAll();
    }
    return () => null;
  }, [toggleExpandAll, allOpen]);

  return (
    <TableContainer>
      <Table>
        <colgroup>
          {columns.map((col) => (
            <col style={{ minWidth: col?.width ?? '10%' }} key={col.field} />
          ))}
        </colgroup>
        <TableHead>
          <TableRow>
            {columns.map((col) =>
              col.field === 'actions' ? (
                <TableCell key={col.field}>
                  <div
                    onClick={handler}
                    className={slideComponentProps.classes.expandButton}
                  >
                    {allOpen ? '-' : '+'}
                  </div>
                </TableCell>
              ) : (
                <TableCell key={col.field} align={col.headerAlign}>
                  {col.sortable !== false ? (
                    <TableSortLabel
                      active={orderBy === col.field}
                      direction={orderBy === col.field ? order : 'asc'}
                      onClick={createSortHandler(col.field)}
                    >
                      {col.headerName}
                    </TableSortLabel>
                  ) : (
                    col.headerName
                  )}
                </TableCell>
              )
            )}
          </TableRow>
        </TableHead>
        {localItems.length > 0 ? (
          <>
            {localItems.map((item: any, index: number) => {
              return (
                <TableBody key={index}>
                  <TableRow
                    className={
                      openArr?.[item?.userid]
                        ? slideComponentProps.classes.selectedRow
                        : null
                    }
                  >
                    {colKeys.map((keyName, keyIndex) => (
                      <TableCell
                        width={
                          columns[keyIndex].width
                            ? columns[keyIndex].width
                            : 100
                        }
                        align={columns[keyIndex].align ?? 'left'}
                        // className={columns[keyIndex]?.cellClassName ? columns[keyIndex].cellClassName : null}
                        key={keyName}
                      >
                        {renderHelper(columns, item, keyName)}
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow
                    className={
                      openArr?.[item?.userid]
                        ? slideComponentProps.classes.selectedRow
                        : null
                    }
                  >
                    <TableCell style={{ padding: '0px 16px' }} colSpan={12}>
                      <Collapse
                        in={openArr?.[item?.userid] ?? false}
                        timeout="auto"
                        unmountOnExit
                      >
                        {SlideComponent?.({
                          index,
                          row: localItems[index],
                          data: slideComponentProps,
                        }) ?? null}
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </TableBody>
              );
            })}
          </>
        ) : (
          <TableBody>
            <TableRow>
              <TableCell colSpan={100} align="center">
                No Rows
              </TableCell>
            </TableRow>
          </TableBody>
        )}
      </Table>
    </TableContainer>
  );
};

export default SlideDataTable;
